import { Box, FlexLayout } from '@deity/falcon-ui';
import type { FC } from 'react';

type MappingEdgeVisualizerProps = {
  mappingEdges: { color: string; dangling: boolean }[];
};
export const MappingEdgeVisualizer: FC<MappingEdgeVisualizerProps> = ({ mappingEdges }) => (
  <FlexLayout justifyContent="space-around" width="full" css={{ minHeight: '100px' }} flexDirection="column">
    {mappingEdges.map((e, i) => (
      <Box
        key={i} // eslint-disable-line react/no-array-index-key
        css={{ backgroundColor: e.color, height: '2px', width: e.dangling ? '50%' : '100%', alignSelf: 'flex-end' }}
      />
    ))}
  </FlexLayout>
);
